import { CategoryTag } from '@/model/response';
import { Identifiable } from '@/model/Identifiable';

export const extractFilterData = (filter: CategoryTag): Identifiable => {
  return {
    id: filter.tag,
    name: filter.name,
  };
};
